const files = require.context(".", true, /\.vue$/);

const BxComponents = {};
files.keys().forEach(key => {
  BxComponents[key.replace(/(\.\/)/g, "")] = files(key).default;
});

export default BxComponents;
